import { gql, TypedDocumentNode } from '@apollo/client';

import { IGetMuriquiProjectQueryGraphQLResponse, IGetMuriquiProjectQueryVariables } from './useGetMuriquiProject.interfaces';

const GET_MURIQUI_PROJECT_WITH_DOWNGRADE_REQUEST = gql`
  query getMuriquiProject($projectId: String!) {
    projects {
      get(id: $projectId) {
        customerDetail(product: QUICKCODES) {
          subscriptionDate
          subscriptions {
            downgradeRequest {
              date
              plan {
                name
              }
            }
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  IGetMuriquiProjectQueryGraphQLResponse,
  IGetMuriquiProjectQueryVariables
>;

export { GET_MURIQUI_PROJECT_WITH_DOWNGRADE_REQUEST };
